import { Container, Grid2 } from "@mui/material";
import ConfirmDialog from "components/common/ConfirmDialog";
import LoadingFullScreen from "components/common/LoadingFullScreen";
import { ACTION_STATES } from "core/actions";
import { cloneDeep, get } from "lodash";
import log from "loglevel";
import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ApiList } from "./container";
import FilmImport from "./filmImport";
import { actions } from "./logic/actions";

function ApiImportHome() {
    const dispatch = useDispatch();

    const acceptStatus = useSelector((state) => state.apiImport.acceptRequestStatus, shallowEqual);
    const [filmReleaseToOpen, setFilmReleaseToOpen] = React.useState(null);
    const isAccepting = acceptStatus === ACTION_STATES.SEND;

    const [filmRelease, setFilmRelease] = React.useState({});
    const importForm = React.useRef();

    useEffect(() => {
        return function clean() {
            dispatch(actions.ON_CLEAR_API_IMPORT.call());
        };
    }, [dispatch]);

    useEffect(() => {
        log.debug(acceptStatus, filmRelease);
        if (acceptStatus === ACTION_STATES.SUCCESS && filmRelease.id) {
            setFilmRelease({});
            dispatch(actions.ON_CLEAR_API_ACCEPT_STATUS.call(ACTION_STATES.NO_REQUEST));
        }
    }, [acceptStatus, dispatch, filmRelease]);

    function handleFilmSelect(filmRelease) {
        setFilmRelease(filmRelease);
    }
    function handleConfirmDiscard() {
        setFilmRelease(cloneDeep(filmReleaseToOpen));
        setFilmReleaseToOpen(null);
    }
    function handleConfirmCancel() {
        setFilmReleaseToOpen(null);
    }

    function onSubmitAccept(selectedId, externalId) {
        dispatch(actions.ON_MATCH_FILM.send({ selectedId, externalId }));
    }

    const selectedFilmId = get(filmRelease, "id", null);

    return (
        (<Container maxWidth={"xl"} className={"atsGlobalContainer"}>
            <ConfirmDialog
                open={!!filmReleaseToOpen}
                message="You made changes to the film. You need to accept or discard film release changes"
                confirmText="Discard"
                closeText="Cancel"
                onConfirm={handleConfirmDiscard}
                onCancel={handleConfirmCancel}
            />
            <LoadingFullScreen open={isAccepting} loadingMessage={"Saving..."} />
            <Grid2 container spacing={3}>
                <Grid2 size={12}>
                    <FilmImport ref={importForm} onSubmitMatch={onSubmitAccept} filmRelease={filmRelease} />
                </Grid2>
                <Grid2 size={12}>
                    <ApiList selectedFilmId={selectedFilmId} onSelectFilm={handleFilmSelect} />
                </Grid2>
            </Grid2>
        </Container>)
    );
}

export default ApiImportHome;
